/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'goal-actions.archive-goal.generic-error-title': 'Não foi possível arquivar a meta',
  'goal-actions.copy-goal.cancel': 'Cancelar',
  'goal-actions.copy-goal.close-modal': 'Fechar modal',
  'goal-actions.copy-goal.error': 'Dê um nome à meta para que todos saibam do que se trata',
  'goal-actions.copy-goal.failed-description': 'Houve um erro ao clonar a meta. Tente de novo mais tarde.',
  'goal-actions.copy-goal.failed-description-forbidden': 'Você não tem permissão para copiar essa meta.',
  'goal-actions.copy-goal.failed-title': 'Não foi possível clonar esta meta.',
  'goal-actions.copy-goal.followers': 'Seguidores',
  'goal-actions.copy-goal.goal-name': 'Nome da meta',
  'goal-actions.copy-goal.include': 'Incluir',
  'goal-actions.copy-goal.links': 'Links',
  'goal-actions.copy-goal.submit': 'Enviar',
  'goal-actions.copy-goal.success-description': 'A meta foi clonada.',
  'goal-actions.copy-goal.success-link': 'Visualizar meta clonada.',
  'goal-actions.copy-goal.success-title': 'Meta {goalName} clonada.',
  'goal-actions.copy-goal.title': 'Copiar meta',
  'goal-actions.follow-goal.follow-error-title': 'Não foi possível seguir a meta',
  'goal-actions.follow-goal.unfollow-error-title': 'Não foi possível deixar de seguir a meta',
  'goal-actions.goal-actions.archive-error-title': 'meta não pôde ser restaurada',
  'goal-actions.goal-actions.archive-goal': 'Arquivar meta',
  'goal-actions.goal-actions.archive-restore-error-description':
    'mudanças de metas não puderam ser salvas. Tente de novo mais tarde.',
  'goal-actions.goal-actions.copy-goal': 'Copiar meta',
  'goal-actions.goal-actions.copy-link': 'Copiar link',
  'goal-actions.goal-actions.follow': 'Seguir',
  'goal-actions.goal-actions.generic-error-description': 'Algo deu errado, tente de novo em alguns minutos.',
  'goal-actions.goal-actions.restore-goal': 'Restaurar meta',
  'goal-actions.goal-actions.share': 'Compartilhar',
  'goal-actions.goal-actions.show-more': 'Mostrar mais',
  'goal-actions.goal-actions.unfollow': 'Deixar de seguir',
  'goal-actions.goal-content.follow-confirmation-description':
    'A gente vai enviar um resumo com as atualizações de todas as metas que você está seguindo na primeira semana do próximo mês.',
  'goal-actions.goal-content.follow-confirmation-title': '🙌🏼 Agora você está seguindo essa meta!',
  'goal-actions.restore-goal.generic-error-title': 'Não foi possível restaurar a meta',
};
